import type { ComponentProps, MouseEventHandler } from 'react';

import { motion } from 'motion/react';

import { cn } from 'utils/cn';
import { ChevronDownIcon, ChevronUpIcon } from '../Icons';
import './ScrollIndicator.css';

export type ScrollIndicatorPosition = 'top' | 'bottom';

interface Props extends Omit<ComponentProps<typeof motion.div>, 'ref'> {
  position: ScrollIndicatorPosition;
}

const ScrollIndicator = ({ position, ...rest }: Props) => {
  const { onClick, style, ...otherProps } = rest;
  const iconOpacity = ((style?.height as number) ?? 40) / 40;
  const isTop = position === 'top';

  return (
    <motion.div
      {...otherProps}
      className={cn(
        'absolute z-[11] overflow-hidden flex justify-center w-full h-md1',
        isTop
          ? 'top-0 pt-xs1 scroll-indicator-top'
          : 'bottom-0 items-end pb-xs1 scroll-indicator-bottom',
        onClick
          ? 'pointer-events-auto cursor-pointer'
          : 'pointer-events-none cursor-default',
        otherProps.className,
      )}
      style={style}
      onClick={onClick as MouseEventHandler<HTMLDivElement>}
    >
      <span
        className="opacity-[var(--si-opacity)]"
        style={{ '--si-opacity': iconOpacity } as React.CSSProperties}
      >
        {isTop ? (
          <ChevronUpIcon color="iconPrimaryInverse" size="sm" />
        ) : (
          <ChevronDownIcon color="iconPrimaryInverse" size="sm" />
        )}
      </span>
    </motion.div>
  );
};

export default ScrollIndicator;
